<template>
    <div class="list">
        <div class="info df aic">
            <div @click="handleOpenavatar(item)" class="df cup">
                <el-avatar :size="24" :src="item.user_avatar_url" @error="true">
                    <img src="@/assets/images/avatar.png" alt="">
                </el-avatar>
            </div>

            <span class="name">{{ item.is_expert == 10 ? item.user_name : item.user_nick_name }}
                <span class="iconfont fs-14 c-9">&#xe60a;</span> {{
                item.to_user_nick_name }}
            </span>
        </div>
        <div class="desc">
            {{ item.taqa_content }}
        </div>
        <div class="like-box df jcfe">
            <el-button type="text" class="df aic" @click="handleReplyPer(item)">
                <img src="@/assets/images/path1.png" alt="">{{ $t('回复') }}
            </el-button>
            <el-button type="text" class="df aic" :class="{ 'have_like': item.have_like == 10 }"
                @click="handleactQuestionLike(item)">
                <span class="iconfont">{{ item.have_like == 10 ? '&#xe656;' : '&#xe61b;' }}</span>
                {{ item.taqa_likes ? item.taqa_likes : $t('点赞') }}
            </el-button>
        </div>
        <!-- 递归调用自身 -->
        <div v-if="item.children && item.children.length > 0">
            <comment-list v-for="(childItem, childIndex) in item.children" :key="childIndex" :item="childItem"
                :handleReplyPer="handleReplyPer" :handleactQuestionLike="handleactQuestionLike" />
        </div>

        <!-- 个人信息 -->
        <avatarTop ref="avatarDialog" @post-submitted="handleAvatarSubmitted" :id="id" />

    </div>
</template>

<script>
import { setuserfollowAdd } from "@api/home";
export default {
    name: 'CommentList',
    props: {
        item: {
            type: Object,
            required: true
        },
        handleReplyPer: {
            type: Function,
            required: true
        },
        handleactQuestionLike: {
            type: Function,
            required: true
        }
    },
    data() {
        return {
            id: 0,
        }
    },
    methods: {
        handleOpenavatar(item) {
            if (item.user_id == 0 || item.user_id == null || item.user_nick_name == 0 || item.user_nick_name == null) {
                return false;
            }
            this.$refs.avatarDialog.openModal();
            this.id = item.user_id;
        },
        // 个人信息谈款
        async handleAvatarSubmitted(id) {

            let res = await setuserfollowAdd({ tuf_be_follow_user_id: id });
            if (res.status == 200) {
                this.$message.success(res.msg);

            }

        },
    }
}
</script>

<style lang="scss" scoped>
.list {
    margin-top: 16px;

    &>div>.list {
        margin-top: 8px;
        // padding-left: 40px;
    }

    .info {
        color: rgb(25, 25, 25);
        font-size: 16px;
        font-weight: 400;
        line-height: 22px;

        .name {
            margin-left: 12px;
            font-family: "MicrosoftYaHeiSemibold";
        }
    }

    .desc {
        margin-left: 36px;
        color: rgb(25, 25, 25);
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
        margin-top: 14px;
    }

    .like-box {
        margin-top: 8px;

        button {
            color: rgb(174, 174, 174);
            font-size: 14px;
            font-weight: 400;
            line-height: 22px;
            padding: 0 8px;

            &.have_like {
                color: rgb(216, 15, 5);
                ;
            }

            img,
            .iconfont {
                width: 16px;
                margin-right: 8px;
            }

            &:hover {
                color: rgb(216, 15, 5);
                ;

            }
        }

        .el-button+.el-button {
            margin-left: 0;
        }
    }
}
</style>